// Varias fotos por producto (plan Pro). La foto principal sigue en image / imgid / imgPath
// (la usan la lista del menú, el panel, la importación y el asistente) y las demás van en
// `fotos`, en orden: [{ url, path }]. En Gratis el producto tiene una sola foto.

// Fotos en total por producto, contando la principal.
export const MAX_PHOTOS = 6;
// Lo que se acepta elegir; antes de subirla se achica (como la portada).
export const PHOTO_MAX_INPUT_BYTES = 20 * 1024 * 1024;
export const PHOTO_MAX_WIDTH = 1600;

const STORAGE_URL = /^https:\/\/firebasestorage\.googleapis\.com\/[^<>"' ]*$/;

// Fotos extra guardadas, limpias (descarta lo que no sea un link de Storage).
export const extraPhotos = (product) => (Array.isArray(product?.fotos) ? product.fotos : [])
    .filter((f) => f && typeof f.url === "string" && STORAGE_URL.test(f.url))
    .slice(0, MAX_PHOTOS - 1);

// Si el plan del negocio muestra más de una foto por producto.
export const galleryAvailable = (business, proOnly) => !proOnly || business?.subscribed === true;

// Links de las fotos que se ven en el detalle del producto, la principal primero.
export const productPhotos = (business, product, proOnly) => {
    const main = product?.image ? [product.image] : [];
    if (!galleryAvailable(business, proOnly)) return main;
    return [...main, ...extraPhotos(product).map((f) => f.url)];
}

// Ruta en Storage de la foto principal (los productos viejos solo tienen imgid).
export const mainPath = (product) => product?.imgPath || (product?.imgid ? "images/" + product.imgid : "");

// Fotos con las que arranca el formulario: { key, url, path } (path vacío si no se sabe).
export const initialPhotos = (product) => {
    if (!product) return [];
    const list = product.image ? [{ key: "main", url: product.image, path: mainPath(product) }] : [];
    // Sin ruta guardada se usa el link, que también sirve para borrarla de Storage.
    return [...list, ...extraPhotos(product).map((f, i) => ({ key: "foto" + i, url: f.url, path: f.path || f.url }))];
}

// Cambios de orden del formulario.
export const movePhoto = (list, from, to) => {
    if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) return list;
    const next = [...list];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    return next;
}

export const makeMain = (list, index) => movePhoto(list, index, 0);

// Problema con el archivo elegido, o null si se puede usar.
export const photoFileProblem = (file) => {
    if (!file) return "Elegí una foto.";
    if (!String(file.type || "").startsWith("image/")) return "Tiene que ser una foto (JPG, PNG o WebP).";
    if (file.size > PHOTO_MAX_INPUT_BYTES) return "La foto pesa más de 20 MB. Probá con una más liviana.";
    return null;
}

// Campos del producto según la lista final de fotos ({ url, path, id } ya subidas), y las
// rutas de Storage que quedaron sin usar (para borrarlas después de guardar).
export const photoFields = (photos, before = []) => {
    const [main, ...rest] = photos;
    const fields = main
        ? { image: main.url, imgid: main.path ? main.path.split("/").pop() : "", imgPath: main.path || "" }
        : { image: null, imgid: null, imgPath: null };
    fields.fotos = rest.slice(0, MAX_PHOTOS - 1).map((p) => ({ url: p.url, path: p.path || "" }));
    const kept = new Set(photos.map((p) => p.path).filter(Boolean));
    const removed = before.map((p) => p.path).filter((path) => path && !kept.has(path));
    return { fields, removed };
}
